import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`


  body{
    overflow: overlay;
  }

  #__next {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  a {
    color: inherit;
    text-decoration: none;
    &:focus-visible {
      border: 2px dashed white;
      outline-offset: 2px;
      outline: 3px dashed #0e3487;
      display: inline-block;
    }
  }

  * {
    box-sizing: border-box;
  }
  /* scrollbar: */

::-webkit-scrollbar {
  width:8px
}
::-webkit-scrollbar-track {
  background:  ${(p) => p.theme.colors.white};
}
::-webkit-scrollbar-thumb {
  background-color:${(p) => p.theme.colors.borderGrey};
  border-radius:10px;
}
::-webkit-scrollbar-thumb:hover {
  background: ${(p) => p.theme.colors.darkBlack};
}


`

export default GlobalStyle
